
  import { hasIntegrationsEnabled } from '@/ui/auth/auth';
  import { t } from '@/ui/i18n/i18n';
  import { defineComponent } from 'vue';
  import NavbarIcon from './NavbarIcon.vue';

  export default defineComponent({
    components: { NavbarIcon },
    setup() {
      return { hasIntegrationsEnabled, t };
    },
  });
